export default {
  images: {
    clear: "https://i.ibb.co/mNGZRzD/Clear.png",
    hail: "https://i.ibb.co/d65vJmc/Hail.png",
    heavyCloud: "https://i.ibb.co/fYFw3kc/Heavy-Cloud.png",
    heavyRain: "https://i.ibb.co/VMCyS5r/Heavy-Rain.png",
    lightCloud: "https://i.ibb.co/447Zm1X/Light-Cloud.png",
    lightRain: "https://i.ibb.co/fpkgYnv/Light-Rain.png",
    shower: "https://i.ibb.co/Jd8LmRj/Shower.png",
    sleet: "https://i.ibb.co/gvLR7wL/Sleet.png",
    snow: "https://i.ibb.co/FnJPtHp/Snow.png",
    thunderStorm: "https://i.ibb.co/YPhXq33/Thunderstorm.png"
  }
};
